<!-- Session settings -->
<div class="w-full flex flex-row justify-between items-center gap-1">
    @if (expandSettingsPanel) {
        <div class="flex flex-col justify-start items-center w-full">
            <div class="flex flex-row justify-between items-center w-full">
                <div class="text-[13px] text-color font-medium leadning-[normal] font-inter"
                    >Session Settings</div
                >
                <p-button
                    size="large"
                    (click)="expandSettingsPanel = !expandSettingsPanel"
                    severity="secondary"
                    [outlined]="true"
                    icon="pi pi-chevron-up"
                    styleClass="!w-6" />
            </div>
            <label
                class="w-full text-left text-[12px] text-color font-medium leadning-[normal] font-inter mt-2"
                for="duration"
                >Duration</label
            >

            <div class="w-full flex items-center gap-1 mt-1">
                <p-select-button
                    class="w-full h-10"
                    styleClass="w-full"
                    [options]="durationOptions"
                    optionLabel="label"
                    [ngModel]="durationValue.value"
                    optionValue="value"
                    [allowEmpty]="false"
                    (onChange)="onSelectedDuration($event)">
                    <ng-template #item let-item>
                        <div class="flex flex-col justify-center items-center font-inter -gap-0.5">
                            <div class="font-semibold text-12 leading-[normal]">{{
                                item.label
                            }}</div>
                            <div class="font-medium text-11n">min</div>
                        </div>
                    </ng-template>
                </p-select-button>
            </div>

            <label
                class="w-full text-left text-[12px] text-color font-medium leadning-[normal] font-inter mt-2"
                for="activity"
                >My Task</label
            >
            <div class="w-full flex items-center gap-1 mt-1">
                <p-select-button
                    class="w-full h-10"
                    styleClass="w-full"
                    [options]="activityOptions"
                    optionLabel="label"
                    [ngModel]="activityValue.value"
                    optionValue="value"
                    (onChange)="onSelectedActivity($event)">
                    <ng-template #item let-item>
                        <div
                            class="flex flex-col justify-center items-center leading-snug font-medium">
                            <fa-icon class="text-[10px]" [icon]="item.icon" />
                            <div class="text-[12px]">{{ item.label }}</div>
                        </div>
                    </ng-template>
                </p-select-button>
            </div>

            <div class="flex flex-row justify-between items-center w-full mt-3">
                <label
                    class="text-left text-[12px] text-color font-medium leadning-[normal] font-inter"
                    for="quitemode"
                    >Quiet Mode:</label
                >
                <p-toggleSwitch
                    class="flex"
                    [dt]="toggleSwitchToken"
                    (onChange)="onToggleQuietMode($event)"
                    [(ngModel)]="quietMode" />
            </div>
        </div>
    } @else {
        <div class="flex w-full gap-1">
            <div class="flex-1">
                <p-button
                    class="w-full"
                    size="large"
                    severity="help"
                    [outlined]="false"
                    styleClass="!h-10 !p-0 w-full"
                    (click)="toggleDuration()">
                    <div class="flex flex-col justify-center items-center font-inter -gap-0.5">
                        <div class="font-semibold text-12 leading-[normal]">{{
                            durationValue.label
                        }}</div>
                        <div class="font-medium text-11n">min</div>
                    </div>
                </p-button>
            </div>

            <div class="flex-1">
                <p-button
                    class="w-full"
                    size="large"
                    severity="help"
                    [outlined]="false"
                    styleClass="!h-10 !p-0 w-full"
                    (click)="toggleActivity()">
                    <div class="flex flex-col justify-center items-center font-inter -gap-0.5">
                        <fa-icon class="text-11n" [icon]="activityValue.icon" />
                        <div class="font-medium text-11n">{{ activityValue.label }}</div>
                    </div>
                </p-button>
            </div>
            @if (quietMode) {
                <div class="flex-1">
                    <p-button
                        class="w-full"
                        size="large"
                        severity="help"
                        [outlined]="false"
                        styleClass="!h-10 !p-0 w-full"
                        (click)="disableQuietMode()">
                        <div
                            class="flex flex-col h-full w-full justify-center items-center font-inter -gap-0.5 relative group hover:opacity-30">
                            <fa-icon class="text-11n" [icon]="faVolumeSlash" />
                            <div class="font-medium text-11n">Quiet</div>
                            <span
                                class="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 pointer-events-none h-full w-full">
                                <i class="pi pi-times text-2xl"></i>
                            </span>
                        </div> </p-button
                ></div>
            }
        </div>
        <p-button
            size="large"
            (click)="expandSettingsPanel = !expandSettingsPanel"
            severity="secondary"
            [outlined]="true"
            styleClass="!w-6 !h-10 !p-0"
            icon="pi pi-chevron-down" />
    }
</div>
